import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Divider } from 'components/_new/Divider';

export const TaggedArticlesSkeleton = () => {
	return (
		<>
			<div className="flex flex-column gap-1">
				<Skeleton width="15rem" height="2rem" className="mb-2" />
				<div className="flex flex-row flex-wrap gap-2">
					{[1, 2, 3].map((i) => (
						<div
							key={i}
							className="flex-1 flex flex-column gap-2 p-3 border-round surface-border"
							style={{
								minWidth: '200px',
								border: '1px solid var(--surface-border)',
								backgroundColor: 'var(--surface-card)',
							}}
						>
							<div className="flex gap-2 align-items-center mb-2">
								<Skeleton shape="circle" size="2rem" />
								<Skeleton width="8rem" height="1.5rem" />
							</div>
							<Skeleton width="100%" height="1rem" />
							<Skeleton width="100%" height="1rem" />
							<Skeleton width="100%" height="1rem" />
							<Skeleton width="80%" height="1rem" />
							<Skeleton width="60%" height="1rem" />
						</div>
					))}
				</div>
			</div>
			<Divider />
		</>
	);
};
